import { ErrorHandler, Injectable, inject } from '@angular/core'
import { AppInsightsService } from './core/telemetry/app-insights.service'

@Injectable({
  providedIn: 'root',
})
export class ErrorLoggingService extends ErrorHandler {
  private appInsights = inject(AppInsightsService)

  handleError(error: any) {
    const exception = error instanceof Error ? error : new Error(String(error?.message ?? error))
    this.appInsights.trackException(exception)
    super.handleError(error)
  }
}
